module.exports = __webpack_public_path__ + "static/yoga-hero-61e465a7e6b7f19b39eafd9f5467fb6e.jpg";